import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/base.service';
import { SessionUserHashManagerService } from '../session-user-hash-manager/session-user-hash-manager.service';

@Injectable({
  providedIn: 'root'
})
export class SubjectsService extends BaseService {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient,
    protected hashManagerService: SessionUserHashManagerService
  ) {
    super(hashManagerService);
    this.apiUrl += this.apiUrl.endsWith("/") ? "" : "/";
  }

  getSubjectList() {
    let options = this.prepareOptions({});
    return this.http.get(this.apiUrl + 'api/LearningSection/GetSubject', options)
      .pipe(
        map((data: any) => {

          return data.body;
        }), catchError(this.handleError('getSubjectList'))
      );
  }

  getStudentSubjects(studentId: number) {
    let requestBody = { studentId: studentId };
    let options = this.prepareOptions(requestBody);
    return this.http.post(this.apiUrl + 'api/Students/ReadStudentsSubjects', requestBody, options)
      .pipe(
        map((data: any) => {

          return data.body;
        }), catchError(this.handleError('getStudentSubjects'))
      );
  }
}
